import { pushSearchSortChangedEvent } from '../searchGtmEvents';
import { normalizeSortMode } from './searchScope';
import { replaceRowsInListSlots } from './searchResultsMarkup';

// Apply one sort mode to the remaining-results list and update toggle button state.
export default function applySortMode($root, mode, pushSortChangeEvent = false) {
  if (!$root || !$root.length) {
    return;
  }
  const normalizedMode = normalizeSortMode(mode);
  const $list = $root.find('.semantic-remaining-results__list');
  if (!$list.length) {
    return;
  }
  // This list contains both semantic results and ad rows; only semantic rows are sortable.
  const originalResultRows = $list.children('li.semantic-remaining-result').toArray();
  if (!originalResultRows.length) {
    return;
  }
  // Keep original row positions so we can map sorted results back into semantic slots.
  const sortedResultRows = originalResultRows.slice();
  const sortAttr = normalizedMode === 'date' ? 'data-date-sort-ms' : 'data-relevance-order';

  sortedResultRows.sort((a, b) => {
    const valA = parseInt($(a).attr(sortAttr), 10) || 0;
    const valB = parseInt($(b).attr(sortAttr), 10) || 0;
    return normalizedMode === 'date' ? valB - valA : valA - valB;
  });

  // Preserve ad slot placement while reordering only semantic result rows.
  replaceRowsInListSlots($list, originalResultRows, sortedResultRows);
  $root.find('[data-sort-mode]').removeClass('is-active');
  $root.find(`[data-sort-mode="${normalizedMode}"]`).addClass('is-active');

  if (pushSortChangeEvent) {
    pushSearchSortChangedEvent(normalizedMode);
  }
}
